import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ErrorPolicyService } from '@mri-platform/angular-error-handling';
import { Observable } from 'rxjs';
import { Mapper } from '../models';
import { MapperEntityService } from './mapper-entity.service';
@Injectable({ providedIn: 'root' })
export class MappersResolver implements Resolve<Mapper[]> {
  constructor(
    private entityService: MapperEntityService,
    private errorPolicyService: ErrorPolicyService
  ) {}

  resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<Mapper[]> {
    return this.entityService.getAll().pipe(this.errorPolicyService.catchHandleReplace([]));
  }
}
